import React, { useState, useMemo, useEffect } from 'react';
import { Checkbox, Col, Row } from 'antd';
import { difference, uniq } from 'lodash-es';

type props = {
  index?: number;
  datas: any;
  setOwnProjectApplications: any;
};
const ProjectApplication = (props: props) => {
  const { datas, index, setOwnProjectApplications } = props;
  const [checkAll, setCheckAll] = useState(datas.checked);

  //字code
  const allChildCodes = datas?.children?.map((d: any) => d?.code) || [];
  //当前授权码默认选中的code
  const defaultCheckedList =
    datas?.children?.filter((d: any) => d.checked)?.map((d: any) => d?.code) || [];
  const [checkedList, setCheckedList] = useState<any[]>(defaultCheckedList);

  useEffect(() => {
    if (datas?.checked && defaultCheckedList?.length === 0) {
      setCheckedList(allChildCodes);
      setOwnProjectApplications((checkeds: any) => {
        const newCodes = uniq([...checkeds, ...allChildCodes]);
        return newCodes;
      });
    }
  }, [datas]);

  const plainOptions = useMemo(() => {
    return (
      datas?.children?.map((c: any) => {
        return {
          ...c,
          label: c?.name,
          value: c?.code,
        };
      }) || []
    );
  }, [datas]);

  const onAssetChange = (e: any) => {
    const isChecked = e.target.checked;
    const childCodes = plainOptions?.map((p: any) => p.code) || [];
    setCheckedList(isChecked ? childCodes : []);
    setCheckAll(isChecked);
    if (isChecked) {
      const checkedCodes = [datas?.code, ...childCodes];
      setOwnProjectApplications((checkeds: any) => {
        const newCodes = uniq([...checkeds, ...checkedCodes]);
        return newCodes;
      });
    } else {
      const checkedCodes = [datas?.code, ...childCodes];
      setOwnProjectApplications((checkeds: any) => {
        const newCodes = difference(checkeds, checkedCodes);
        return newCodes;
      });
    }
  };

  const onOptionChange = (list: any) => {
    const childCodes = plainOptions?.map((p: any) => p.code) || [];
    let newLists = [...list];
    //当前点击操作是选中还是取消选中
    const currentOptionType = newLists?.length > checkedList?.length ? 'add' : 'cancel';
    //当前点击操作的选项code
    let currentOptionCode = '';
    if (currentOptionType === 'add') {
      currentOptionCode = difference(newLists, checkedList)?.[0] || '';
    } else {
      currentOptionCode = difference(checkedList, newLists)?.[0] || '';
    }
    //元车位需要特殊处理
    //1、置业顾问管理（code:meta_parking.adviserManage）取消勾选，需要订单管理和IM消息同时取消勾选
    if (currentOptionType === 'cancel' && currentOptionCode === 'meta_parking.adviserManage') {
      newLists = difference(newLists, ['meta_parking.order', 'meta_parking.imMessage']);
    }
    //2、勾选订单管理(code :meta_parking.order)或者IM消息(code:meta_parking.imMessage)，需要同时勾选置业顾问管理
    if (
      currentOptionType === 'add' &&
      (currentOptionCode === 'meta_parking.order' ||
        currentOptionCode === 'meta_parking.imMessage') &&
      !newLists?.includes('meta_parking.adviserManage')
    ) {
      newLists.push('meta_parking.adviserManage');
    }
    setCheckedList(newLists);
    setCheckAll(newLists.length === plainOptions.length);
    if (newLists?.length === 0) {
      //全部取消
      const checkedCodes = [datas?.code, ...childCodes];
      setOwnProjectApplications((checkeds: any) => {
        const newCodes = difference(checkeds, checkedCodes);
        return newCodes;
      });
    } else {
      setOwnProjectApplications((checkeds: any) => {
        //先取消
        let newCodes = difference(checkeds, childCodes);
        //再选中
        return uniq([...newCodes, ...newLists, datas.code]);
      });
    }
  };

  return (
    <Row style={{ marginTop: index === 0 ? '8px' : '12px' }}>
      <Col span={5}>
        <div style={{ lineHeight: 2.3 }}>
          <Checkbox
            indeterminate={checkedList.length > 0 && datas?.children?.length > checkedList.length}
            onChange={onAssetChange}
            checked={checkAll}
            disabled={datas?.disabled || false}
          >
            {datas?.name}
          </Checkbox>
        </div>
      </Col>
      <Col span={datas?.children?.length > 0 ? 19 : 0}>
        <div
          style={{
            width: 350,
            backgroundColor: '#f2f3f5',
            paddingLeft: '12px',
          }}
        >
          <Checkbox.Group onChange={onOptionChange} value={checkedList} options={plainOptions} />
        </div>
      </Col>
    </Row>
  );
};

export default React.memo(ProjectApplication);
